var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule-section"},[_c('div',{staticClass:"schedule-section__heading"},[(_vm.dayIndex == 0)?_c('h2',[_vm._v("VIEW YOUR FULL ITINERARY")]):_c('h2'),_c('h2',[_vm._v(_vm._s(_vm._f("uppercase")(_vm._f("formatDate")(_vm.date))))])]),_vm._l((_vm.times),function(ref,x){
var starts_at = ref.starts_at;
var ends_at = ref.ends_at;
var entries = ref.entries;
return _c('ScheduleTime',{key:x,attrs:{"starts_at":starts_at,"ends_at":ends_at,"entries":entries}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }